'use client';

import { CaretRight, CaretDown } from '@phosphor-icons/react';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  faqs: FAQItem[];
  title?: string;
}

export default function FAQ({
  faqs,
  title = 'Frequently asked questions',
}: FAQProps) {
  return (
    <section className='section-container w-full bg-white'>
      <div className='flex w-full flex-col items-center justify-center'>
        <h2 className='mb-[1.88rem] text-center text-2xl font-semibold text-gray-800 md:mb-14 md:text-[44px]'>
          {title}
        </h2>
        <div className='w-full space-y-2'>
          {faqs.map((faq, index) => (
            <Disclosure
              key={faq.question}
              as='div'
              className='pt-6'
              defaultOpen={index === 0}
            >
              {({ open }) => (
                <>
                  <DisclosureButton className='flex w-full items-start justify-between text-left'>
                    <h2 className='text-lg font-medium leading-7 md:text-2xl'>
                      {faq.question}
                    </h2>
                    <span className='ml-6 flex h-7 items-center'>
                      {open ? (
                        <CaretDown
                          className='h-6 w-6 text-[#6137E0]'
                          aria-hidden='true'
                        />
                      ) : (
                        <CaretRight
                          className='h-6 w-6 text-[#6137E0]'
                          aria-hidden='true'
                        />
                      )}
                    </span>
                  </DisclosureButton>
                  <DisclosurePanel className='mt-2 pr-12'>
                    <div className='text-base leading-7 text-gray-600'>
                      {faq.answer.split('\n').map((line, i) => (
                        <div
                          key={i}
                          className='mb-1'
                          dangerouslySetInnerHTML={{ __html: line }}
                        />
                      ))}
                    </div>
                  </DisclosurePanel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
}
